<template>
  <div>
    <el-form>
      <el-upload
        ref="upload"
        accept=".csv"
        :file-list="fileList"
        :action="action"
        list-type="text"
        :headers="headers"
        :data="data"
        :on-success="onUploadSuccess"
        :on-error="onUploadError"
      >
        <el-button slot="trigger" size="small" type="primary"
          >Upload CSV</el-button
        >
        <div slot="tip" class="el-upload__tip">
          A CSV file with at least 2 columns: Email and Feature
        </div>
      </el-upload>
    </el-form>
  </div>
</template>
<script>
import config from "@/config.js";
import { mapGetters } from "vuex";

export default {
  name: "beta-features",
  data() {
    return {
      fileList: [],
      data: null,
    };
  },
  computed: {
    ...mapGetters(["token"]),
    headers() {
      return { Authorization: "JWT " + this.token };
    },
    action() {
      const baseUrl = `${config.API_BASE_URL}/admin`;
      return `${baseUrl}/product/beta_features/upload_csv`;
    },
  },
  methods: {
    onUploadSuccess() {
      this.$notify.success({
        title: "Uploaded Beta Features CSV successfully",
      });
    },
    onUploadError(error) {
      this.$notify.error({
        title: `Failed to upload Beta Features CSV: ${error}`,
      });
    },
  },
};
</script>
